import ExternalPage from './ExternalPage';

export default ExternalPage;
